import { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WHATSAPP_NUMBER = '393755148808';
const DEFAULT_MESSAGE = 'Ciao, vorrei informazioni su un immobile...';

export function WhatsAppWidget() {
  const [tooltip, setTooltip] = useState(true);

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <div className="fixed bottom-6 left-6 z-50 flex items-end flex-row-reverse gap-3" data-testid="whatsapp-widget">
      {/* Tooltip */}
      {tooltip && (
        <div className="hidden sm:flex items-center bg-white rounded-xl shadow-xl px-4 py-3 animate-fadeIn max-w-[220px]">
          <p className="font-sans text-sm text-text-main leading-snug">
            Hai bisogno di aiuto? Scrivici su <strong className="text-[#25D366]">WhatsApp</strong>!
          </p>
          <button
            onClick={(e) => { e.stopPropagation(); setTooltip(false); }}
            className="ml-2 text-text-muted hover:text-text-main flex-shrink-0"
            data-testid="whatsapp-tooltip-close"
          >
            <X size={14} />
          </button>
        </div>
      )}

      {/* Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 bg-[#25D366] hover:bg-[#1ebe5b] text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:scale-110"
        data-testid="whatsapp-button"
        aria-label="Contattaci su WhatsApp"
      >
        <MessageCircle size={28} fill="white" strokeWidth={0} />
      </a>
    </div>
  );
}
